import React from "react";
import DialogSearch from "../DialogSearch";
import MUIDialogActions from "@mui/material/DialogActions";
import MUIButton from "@mui/material/Button";
import TileMarketingCampaign from "../../Tile/TileMarketingCampaign";
import PropTypes from "prop-types";
import MarketingCampaign from "../../../Utility/Crud/MarketingCampaign";
import MUICheckbox from "@mui/material/Checkbox";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchMarketingCampaign extends DialogSearch {
  static contextType = MainContext; // For legacy class components

  /**
   * Searches for dpartments by several name combinations or ID.
   *
   * @param {string} query The search query.
   * @returns A list of filtered marketingCampaigns.
   */
  getSearchResults(query) {
    return MarketingCampaign.search(this.state.data, query, true);
  }

  /**
   * Gets the data that should be used in this dialog. Data can be manually
   * passed via the data prop, otherwise it falls back to the global list.
   *
   * @returns {array}
   */
  getData() {
    if (this.props.data) {
      return this.props.data;
    } else {
      return Object.values(this.context.marketingCampaignsIndexed);
    }
  }

  /**
   * @param {object} marketingCampaign The marketingCampaign object.
   * @param {Function} onClick A function to call when clicking the tile.
   * @returns A TileMarketingCampaign component for this marketingCampaign.
   */
  renderTile(marketingCampaign) {
    return (
      <TileMarketingCampaign
        key={marketingCampaign.id}
        marketingCampaign={marketingCampaign}
      />
    );
  }

  /**
   * @returns The maximum number of results that can be rendered. Set to
   * Infinity to remove the cap. Just be aware that rendering too many items
   * is not performant or generally useful.
   */
  getMaxResults() {
    return Infinity;
  }
}
